import React from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import queryString from 'query-string';
import { FormattedMessage } from 'react-intl';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import LinearProgress from '@material-ui/core/LinearProgress';
import { authRoute } from '../../routes';
import Splash from '../../components/Splash';
import ImmutablePropsToJS from '../../utils/ImmutablePropsToJS';
import { getIsSignedIn } from './selectors';
import {
  persistStringToLocalStorage,
  getLocalStorageItem
} from '../utils/localStorage';

const styles = theme => ({
  error: {
    color: 'red',
    fontWeight: 500,
    marginTop: theme.spacing(1)
  }
});

const getErrorMessage = location =>
  queryString.parse(location.search).errorMessage;

const getRedirect = location => queryString.parse(location.search).redirect;

const initiateSSOAuthRequest = () => {
  const relayState = encodeURIComponent(
    `${window.location.origin}${authRoute()}`
  );
  window.location.replace(
    `${process.env.REACT_APP_AUTH_API_URL}/saml/sso?relayState=${relayState}`
  );
};

export class LoginView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isSigningIn: false
    };
  }

  componentDidMount() {
    const { isSignedIn, location } = this.props;

    const redirect = getRedirect(location);

    if (redirect) {
      persistStringToLocalStorage('redirect', redirect);
    }

    if (!isSignedIn && !getErrorMessage(location)) {
      initiateSSOAuthRequest();
      this.setState({ isSigningIn: true });
    }
  }

  render() {
    const { classes, location, isSignedIn } = this.props;

    if (isSignedIn) {
      return <Redirect to={getLocalStorageItem('redirect') || '/'} />;
    }

    const errorMessage = getErrorMessage(location);

    const errorContent = errorMessage ? (
      <Typography className={classes.error}>{errorMessage}</Typography>
    ) : null;

    const { isSigningIn } = this.state;

    const signInContent = isSigningIn ? (
      <>
        <Typography gutterBottom align="center" variant="caption">
          <FormattedMessage id="login.contentSigningIn" />
        </Typography>
        <LinearProgress color="secondary" />
      </>
    ) : null;

    const actions = !isSigningIn ? (
      <Button
        className={classes.submit}
        type="submit"
        size="small"
        color="secondary"
        onClick={initiateSSOAuthRequest}
      >
        <FormattedMessage id="login.buttonSignIn" />
      </Button>
    ) : null;

    return (
      <Splash
        actions={actions}
        content={
          <>
            {signInContent}
            {errorContent}
          </>
        }
      />
    );
  }
}

export default withStyles(styles)(
  connect(state => ({
    isSignedIn: getIsSignedIn(state)
  }))(ImmutablePropsToJS(LoginView))
);
